import { type WithRef } from '@principle-theorem/shared';
import { type IMultiTreatmentConfiguration } from './multi-treatment-configuration';
import { type ITreatmentConfiguration } from './treatment-configuration';

export type TreatmentTypeConfiguration =
  | WithRef<ITreatmentConfiguration>
  | WithRef<IMultiTreatmentConfiguration>;
